/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

/* globals window, sessionStorage */

import { Bold, Italic, Underline, Strikethrough, Subscript, Superscript, Code } from '@ckeditor/ckeditor5-basic-styles';
import { FontBackgroundColor, FontColor, FontFamily, FontSize } from '@ckeditor/ckeditor5-font';
import { TableToolbar, TableCaption, TableProperties, TableCellProperties } from '@ckeditor/ckeditor5-table';
import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import { CKBox, CKBoxImageEdit } from '@ckeditor/ckeditor5-ckbox';
import { PictureEditing, ImageInsert, ImageResize, AutoImage } from '@ckeditor/ckeditor5-image';
import { AIAssistant, OpenAITextAdapter } from '@ckeditor/ckeditor5-ai';

// Umberto combines all `packages/*/docs` into the `docs/` directory. The import path must be valid after merging all directories.
import ClassicEditor from '../build-classic.js';

ClassicEditor.builtinPlugins.push(
	AIAssistant,
	OpenAITextAdapter,
	Bold,
	CKBox,
	PictureEditing,
	ImageInsert,
	ImageResize,
	AutoImage,
	CKBoxImageEdit,
	Code,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	Italic,
	RemoveFormat,
	Strikethrough,
	Subscript,
	Superscript,
	TableCaption,
	TableCellProperties,
	TableProperties,
	TableToolbar,
	Underline
);

window.ClassicEditor = ClassicEditor;

const sessionStorageKey = 'CKEditor/AIFormView/PromptHistory';

if ( !sessionStorage.getItem( sessionStorageKey ) ) {
	sessionStorage.setItem( sessionStorageKey, JSON.stringify( [
		// If you update these, make sure you update the guide content too.
		{ id: 'pre-loaded-guide-prompt-1', prompt: 'Write a detailed guide for a one-day walking tour of Barcelona.' },
		{ id: 'pre-loaded-guide-prompt-2', prompt: 'List the top 5 keywords related to traveling.' },
		{ id: 'pre-loaded-guide-prompt-3', prompt: 'Fill empty cells with correct values.' }
	] ) );
}
